/**
 * Get user role based on email
 * @param {string} email - User email address
 * @returns {string} - 'admin' or 'promotion' or 'grand' or 'user'
 */
const PROMOTION_ONLY_EMAILS = new Set([
  'grandkafani2026@grand.dev',
  'grandkafani2026a@grand.dev',
]);

export const getUserRole = (email) => {
  if (!email) return 'user';
  
  const emailLower = email.toLowerCase();

  if (PROMOTION_ONLY_EMAILS.has(emailLower)) {
    return 'promotion';
  }
  
  if (emailLower.includes('admin')) {
    return 'admin';
  }
  
  if (emailLower.includes('grand')) {
    return 'grand';
  }
  
  return 'user';
};

/**
 * Check if user has access to a route
 * @param {string} path - Route path
 * @param {string} email - User email
 * @returns {boolean} - true if user has access
 */
export const hasRouteAccess = (path, email) => {
  const role = getUserRole(email);
  
  // Admin can access everything
  if (role === 'admin') {
    return true;
  }

  // Promotion-only users can access only promotion routes
  if (role === 'promotion') {
    return path.startsWith('/promotion');
  }
  
  // Grand users can only access quiz routes
  if (role === 'grand') {
    return path.startsWith('/quiz');
  }
  
  // Default: no access for other users
  return false;
};

/**
 * Get user email from localStorage
 * @returns {string|null} - User email or null
 */
export const getUserEmail = () => {
  return localStorage.getItem('userEmail');
};

/**
 * Get default route for role
 * @param {string} email - User email address
 * @returns {string} - default route
 */
export const getDefaultRoute = (email) => {
  const role = getUserRole(email);

  if (role === 'promotion') return '/promotion/entries';
  if (role === 'grand') return '/quiz/view';
  if (role === 'admin') return '/banner/view';
  return '/login';
};

